import PropTypes from 'prop-types';

import { getPostType, IG_POST_TYPES } from '@/lib/posts/postTypes';
// Lib
import { INSTAGRAM } from '@/lib/socialProfile';

// Components
import Post from '@/components/base/Post';
import { AlbumPostIcon } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/AlbumPostIcon';

const InstagramAlbumPost = ({ data, shouldDisplayIcon }) => {
    const type = getPostType({ network: INSTAGRAM, type: data?.type });

    return (
        <Post data={data} className="w-full">
            <Post.Content className="relative w-full">
                <AlbumPostIcon
                    show={type && type !== IG_POST_TYPES.TYPE_PHOTO && shouldDisplayIcon}
                    type={type}
                />
                <div className="square relative">
                    <Post.Image />
                </div>
            </Post.Content>
        </Post>
    );
};

InstagramAlbumPost.propTypes = {
    data: PropTypes.object
};

export default InstagramAlbumPost;
